<template>
    <section class="filter-bar">
        <slot name="right"></slot>
        <template>
            <template v-for="(filter,index) in value">
                <v-chip :key="index" label small v-if="!options[filter.column_name].quickFilter">
                    <v-avatar left>
                        <v-icon small @click="deleteItemFromValue(index)">mdi-window-close</v-icon>
                    </v-avatar>
                    <span class="text-truncate">
                        {{ options[filter.column_name].caption }}
                        {{ $t('filter_operands')[filter.operand] }}
                        <span v-if="['IsNotNull','IsNull'].indexOf(filter.operand) < 0">
                            {{ getFilterValue(filter) }}
                        </span>
                    </span>
                </v-chip>
            </template>
            <v-btn class="mx-2" small text @click="openFilterEditor">
                <span class="pl-2">+</span>
                افزودن فیلتر
            </v-btn>
            <v-dialog :value="!!temporaryFilters" persistent width="1000">
                <v-card>
                    <v-card-title class="grey lighten-4">
                        <span>فیلتر ها</span>
                        <v-spacer></v-spacer>
                        <v-btn text icon @click="temporaryFilters = null">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="pt-4">
                        <template v-for="(filter,index) in temporaryFilters">
                            <div class="row" :key="index" v-if="!options[filter.column_name] || !options[filter.column_name].quickFilter">
                                {{filter.column_name}}
                                <div class="col-md-3">
                                    <v-autocomplete
                                            autocomplete="off"
                                            v-model="filter.column_name"
                                            :items="Object.values(options)"
                                            :label="$t('column_name')"
                                            item-text="caption"
                                            item-value="key"
                                            hide-details
                                            dense
                                            outlined
                                            single-line
                                    ></v-autocomplete>
                                </div>
                                <div class="col-md-3" v-if="filter.column_name">
                                    <v-autocomplete
                                            v-model="filter.operand"
                                            :items="operands"
                                            label="نوع فیلتر"
                                            item-text="value"
                                            item-value="key"
                                            hide-details
                                            dense
                                            outlined
                                            single-line
                                    >
                                    </v-autocomplete>
                                </div>
                                <!-- Other -->
                                <div class="col-md-5" v-if="filter.column_name && ['IsNotNull','IsNull'].indexOf(filter.operand) < 0">
                                    <teamplate v-if="options[filter.column_name].type === 'timestamp'">
                                        <date-picker
                                                v-model="filter.value"
                                                format="X"
                                                :multiple="canMultiSelect(filter)"
                                                :range="canRangeSelect(filter)"
                                                display-format="jYYYY/jMM/jDD HH:mm:ss"
                                                type="datetime"
                                                clearable
                                        />
                                    </teamplate>
                                    <teamplate v-else-if="options[filter.column_name].type === 'enum'">
                                        <v-autocomplete
                                                v-model="filter.value"
                                                :items="options[filter.column_name].options"
                                                :label="$t('filter_value')"
                                                item-text="value"
                                                item-value="key"
                                                hide-details
                                                dense
                                                :multiple="canMultiSelect(filter)"
                                                outlined
                                                single-line
                                        >
                                        </v-autocomplete>
                                    </teamplate>
                                    <teamplate v-else>
                                        <v-text-field
                                                v-model="filter.value"
                                                :type="options[filter.column_name].type"
                                                :placeholder="$t('filter_value')"
                                                outlined
                                                single-line
                                                hide-details
                                                dense
                                        >
                                        </v-text-field>
                                    </teamplate>
                                </div>
                                <div class="col-md-1 text-center" v-if="filter.column_name">
                                    <v-btn fab outlined icon x-small color="red" class="mt-1"
                                           @click="deleteItemFromTemporaryFilters(index)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </template>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-btn color="info" text @click="addNewFilter()">
                            <v-icon class="ml-1">mdi-plus</v-icon>
                            افزودن فیلتر جدید
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" text @click="temporaryFilters = null">
                            انصراف
                        </v-btn>
                        <v-btn color="primary" text @click="applyTemporaryFilters">
                            اعمال
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <v-spacer></v-spacer>
        <slot name="append-left"></slot>
    </section>
</template>

<script>
    export default {
        props: {
            value : Array,
            options : Object,
        },
        created() {
        },
        data() {
            return {
                dialog: false,
                temporaryFilters : null
            }
        },
        computed: {
            operands(){
                return Object.keys(this.$t("filter_operands")).map(key => {
                    return {
                        key,
                        value: this.$t("filter_operands")[key]
                    }
                });
            }
        },
        methods: {
            canMultiSelect(filter){
                return ['In','NotIn'].indexOf(filter.operand) >= 0
            },
            canRangeSelect(filter){
                return ['Between'].indexOf(filter.operand) >= 0
            },
            getDefaultFilter(){
                return {
                    column_name: undefined,
                    operand: undefined,
                    value: undefined
                }
            },
            getFilterValue(filter){
                let filterOption = this.options[filter.column_name];
                let value = filter.value;

                if(!Array.isArray(value)){
                    value = [value];
                }

                switch (filterOption.type){
                    case 'enum':
                        value.forEach((item, index)=>{
                            value[index] = this.getLabelFromOption(filterOption.options,item)
                        });
                    break;
                    case 'timestamp':
                        value.forEach((item, index)=>{
                            value[index] = this.getJalaliDate(value[index] * 1000);
                        });
                        break;
                }
                return Array.isArray(filter.value) ? value : value.pop();
            },
            getLabelFromOption(options,key){
                let value = null;
                options.forEach((option)=>{
                    if(key == option.key){
                        value = option.value;
                    }
                });
                return value;
            },
            deleteItemFromValue(index){
                this.$delete(this.value, index)
            },
            deleteItemFromTemporaryFilters(index){
                this.$delete(this.temporaryFilters, index)
            },
            addNewFilter(){
                this.temporaryFilters.push(this.getDefaultFilter())
            },
            openFilterEditor(){
                this.temporaryFilters = JSON.parse(JSON.stringify(this.value));
            },
            applyTemporaryFilters(){
                this.temporaryFilters.forEach((filter,index)=>{
                    this.$set(this.value, index, filter);
                });
                this.temporaryFilters = null;
            }
        },
        watch: {
        }
    }
</script>